/**
 * Extracts the language from a BCP-47 locale string
 *
 * Will return 'fr' for 'fr-CH' for instance
 */
export const language = (locale: string) => locale.split(',')[0].split('-')[0];
